import React, { Component } from 'react';
import { formatDecimal, rupiah } from 'utils/formatter';
import _sortBy from 'lodash/sortBy';
import moment from 'moment';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import { customersRequest } from 'actions/customers/list';
import { connect } from 'react-redux';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import WarningMessage from 'components/WarningMessage';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import _ from 'lodash';
import { MOBILE_APP_VERSION_WARNING } from '../constants';
import MenuTitleLoyalty from '../Components/MenuTitleLoyalty';
import ReactivateConfirmModal from './ReactivateConfirmModal';
import DeactivateConfirmModal from './DeactivateConfirmModal';
import SuccessfulModal from './SuccessfulModal';
import GainPointList from '../Components/RewardList/GainPointList';
import RewardList from '../Components/RewardList';
import styles from './Existing.css';
import ResetLoyaltyModal from './ResetLoyaltyModal';

class Existing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeactivateModal: false,
      showReactivateModal: false,
      showResetModal: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(
      customersRequest(
        {
          page: 1,
          keyword: '',
          type: 'ALL',
        },
        []
      )
    );
    clevertapCustomersLoyalty.showManageLoyalty();
  }

  render() {
    const spendingAmount = this.props.earning_rules[0].amount;
    let status;
    let active;
    let statusFont = 'success-font';
    const dangerFont = 'danger-font';
    if (this.props.status === 'ACTIVE') {
      status = 'Active';
      active = true;
    } else {
      statusFont = dangerFont;
      active = false;
      status = `Inactive since ${moment(this.props.inactive_since).format(
        'DD MMM YYYY'
      )}`;
    }

    const {
      loyaltySubscription: { subscriptionDetail },
    } = this.props;

    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];

    const loyaltyMemberTotal = this.props.summary.total_loyalty_member;
    const remainingQuota = detailPro.is_active
      ? 'Unlimited'
      : Math.max(
          parseInt(detailBasic.properties.LOYALTY_MEMBER_LIMIT) -
            loyaltyMemberTotal,
          0
        );
    const remainingQuotaFont = _.isNumber(remainingQuota) ? dangerFont : '';

    let resetEnabled = false;
    for (const detail of Object.values(subscriptionDetail)) {
      if (
        detail.is_active &&
        detail.properties.CAN_RESET_LOYALTY_PROGRAM === 'true'
      ) {
        resetEnabled = true;
      }
    }

    this.props.change('active', active);
    return (
      <div>
        <div className={`row ${styles['menu-title-loyalty-row']}`}>
          <MenuTitleLoyalty
            menuTitle="Loyalty Program"
            loyaltySubscription={this.props.loyaltySubscription}
            goToSubscribeView={this.props.goToSubscribeView}
          />
          <div className={`col-md-4`}>
            <div style={{ width: '270px', float: 'right' }}>
              {resetEnabled && (
                <div
                  className={`btn`}
                  style={{ color: 'red', borderColor: 'red' }}
                  onClick={this._showReset}
                >
                  Reset Program
                </div>
              )}
              <div
                className={`btn btn-primary`}
                style={{ float: 'right' }}
                onClick={this._showEdit}
              >
                Edit Program
              </div>
              <DeactivateConfirmModal
                show={this.state.showDeactivateModal}
                close={this._closeDeactivateModal}
                confirm={this._confirmDeactivate}
              />
              <ReactivateConfirmModal
                show={this.state.showReactivateModal}
                close={this._closeReactivateModal}
                confirm={this._confirmReactivate}
              />
              <ResetLoyaltyModal
                show={this.state.showResetModal}
                close={this._closeResetModal}
                confirm={this._confirmReset}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div style={{ paddingRight: '38px' }} className="col-md-6">
            <div className={styles['section-label']}>Program Status</div>
            <form>
              <div
                className={styles['program-info']}
                style={{ paddingTop: '10px' }}
              >
                <div style={{ display: 'inline-block' }}>
                  <span
                    className={`${styles['program-info-chosen']} ${
                      styles[statusFont]
                    }`}
                  >
                    <b>{status}</b>
                  </span>
                </div>
                <div style={{ float: 'right' }}>
                  <Field
                    component={SwitchField}
                    disabled={
                      !detailPro.is_active &&
                      this.props.earning_rules[0].type === 'ITEM'
                    }
                    disabledTooltipText="Your current program is only available in CRM Pro. Upgrade your subscription or edit your program to reactivate"
                    name="active"
                    type="checkbox"
                    onText="ON"
                    offText="OFF"
                    onClick={this._changeLoyaltyStatus}
                  />
                </div>
              </div>
            </form>
            <div className={styles['program-info']}>
              Created at:{' '}
              <span className={styles['program-info-chosen']}>
                {' '}
                {moment(this.props.created_at).format('DD MMM YYYY')}
              </span>
            </div>
            <div className={`${styles['program-info']}`}>
              Created by:{' '}
              <span className={styles['program-info-chosen']}>
                {' '}
                {this.props.created_by}{' '}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className={styles['section-label']}>Member Registration</div>
            <div className={styles['program-info']}>
              <span
                className={styles['program-info-chosen']}
                style={{ fontSize: '15px' }}
              >
                Registered members: {loyaltyMemberTotal}
              </span>
            </div>
            <div className={styles['program-info']}>
              <span
                className={`${styles['program-info-chosen']} ${
                  styles[remainingQuotaFont]
                }`}
                style={{ fontSize: '15px' }}
              >
                Remaining quota: {remainingQuota}
              </span>
            </div>
            {this.props.earning_rules[0].type === 'ITEM' && (
              <div style={{ marginTop: '20px' }}>
                <WarningMessage
                  message={MOBILE_APP_VERSION_WARNING}
                  iconStyle={`circle`}
                />
              </div>
            )}
          </div>
        </div>
        <div className="row top30">
          {/* <div style={{paddingRight: '38px'}} className='col-md-6'>
            <div className={styles['section-label']}>In-Store Signage</div>
            <div className={styles['program-info']}>
              <span className={styles['program-info-chosen']}>Print out free in-store signage to advertse your loyalty program to your customers.</span>
            </div>
            <div className={styles['program-info']}>
              <div className={`btn ${styles['in-store-button']}`}>Download Table Tent</div>
            </div>
          </div> */}
          <div style={{ paddingRight: '38px' }} className="col-md-6">
            <div className={styles['section-label']}>Program Configuration</div>
            <div className={styles['program-info']}>
              <span className={styles['program-info-chosen']}>
                No expiry date, until deactivated manually.
              </span>
            </div>
            <div className={styles['program-info']}>
              <span className={styles['program-info-chosen']}>
                {this.props.is_sent_validation_code
                  ? 'Use SMS validation code for every reward redemption'
                  : 'Do not use SMS validation code for reward redemptions'}
              </span>
            </div>
          </div>
        </div>
        <div className="row top30">
          <div className="col-md-12">
            <div className={styles['section-label']}>Your Loyalty Program</div>
            {this.props.earning_rules &&
              this.props.earning_rules[0].type === 'ITEM' && (
                <div style={{ height: '60px' }}>
                  <div className={`col-md-1 ${styles['earning-rule-image']}`}>
                    <img src={require('assets/images/groceries.png')} />
                  </div>
                  <div className="col-md-10">
                    <p style={{ margin: '0px' }}>
                      <b>
                        Gain points from buying item
                        {this.props.earning_rules[0].item_rules[0].type ===
                          'CATEGORY' && <span>s in a category</span>}
                      </b>
                    </p>
                    <p style={{ margin: '0px', lineHeight: '23px' }}>
                      <i>
                        New members gain{' '}
                        {formatDecimal(this.props.new_member_point)} point(s)
                      </i>{' '}
                    </p>
                  </div>
                </div>
              )}
            {this.props.earning_rules &&
              this.props.earning_rules[0].type === 'ITEM' && (
                <div>
                  <p style={{ marginBottom: '5px' }}>
                    Point rule: Members gain{' '}
                    {formatDecimal(this.props.earning_rules[0].point)}{' '}
                    {this.props.earning_rules[0].item_rules[0].type ===
                    'CATEGORY' ? (
                      <span>
                        {' '}
                        point(s) from items in the following categories:
                      </span>
                    ) : (
                      <span> point(s) from the following items:</span>
                    )}{' '}
                  </p>
                </div>
              )}
            {this.props.earning_rules &&
              this.props.earning_rules[0].type === 'SPENDING' && (
                <div style={{ height: '80px' }}>
                  <div className={`col-md-1 ${styles['earning-rule-image']}`}>
                    <img src={require('assets/images/rp.png')} />
                  </div>
                  <div className="col-md-10">
                    <p style={{ margin: '0px' }}>
                      <b>Gain points from total Rp. spent</b>
                    </p>
                    <p style={{ margin: '0px', lineHeight: '23px' }}>
                      <i>
                        New members gain{' '}
                        {formatDecimal(this.props.new_member_point)} points{' '}
                      </i>
                    </p>
                    <p style={{ margin: '0px' }}>
                      Point rule: Members gain{' '}
                      {formatDecimal(this.props.earning_rules[0].point)} for
                      every {rupiah(spendingAmount)} spent
                    </p>
                  </div>
                </div>
              )}
            {this.props.earning_rules &&
              this.props.earning_rules[0].type === 'ITEM' && (
                <GainPointList itemRules={this._toDisplayGainPoints()} />
              )}
          </div>
        </div>
        <div className="row top30">
          <div className="col-md-12">
            <div className={styles['section-label']}>Reward List</div>
            <RewardList rewards={this._toDisplayRewards()} />
          </div>
        </div>
        <SuccessfulModal
          close={this.props.closeSuccessModal}
          show={this.props.showSuccessModal}
        />
      </div>
    );
  }

  _toDisplayRewards = () => {
    const rewards = this.props.rewards.map(reward => {
      return {
        rewardType: reward.reward_type,
        point: reward.redeem_point,
        discount: reward.discount,
        discountType: reward.discount_type,
        maximumDiscount: reward.max_discount_amount,
        minimumPurchase: reward.min_purchase_amount,
        rewardItems: reward.reward_items,
      };
    });

    return _sortBy(rewards, ['point']);
  };

  _toDisplayGainPoints = () => {
    const itemRules = [];
    if (this.props.earning_rules[0].type === 'ITEM') {
      this.props.earning_rules[0].item_rules.forEach(element => {
        itemRules.push({
          type: element.type,
          itemName: element.item_name,
          categoryName: element.category_name,
          itemVariantNames: element.item_variant_names,
          point: this.props.earning_rules[0].point,
        });
      });
    }
    return _sortBy(itemRules, ['point']);
  };

  _showEdit = () => {
    this.props.showEdit();
    clevertapCustomersLoyalty.editProgramStart();
  };

  _confirmReset = () => {
    this.props.showReset();
    clevertapCustomersLoyalty.resetProgramStart();
  };

  _closeResetModal = () => {
    this.setState({
      showResetModal: false,
    });
  };

  _showReset = () => {
    this.setState({
      showResetModal: true,
    });
  };

  _onClickDeactivate = () => {
    this.setState({
      showDeactivateModal: true,
    });
  };

  _confirmDeactivate = () => {
    this.props.deactivateLoyalty({ id: this.props.id });
    this._closeDeactivateModal('deactivate');
    clevertapCustomersLoyalty.deactivateLoyalty(this.props);
  };

  _closeDeactivateModal = () => {
    this.setState({
      showDeactivateModal: false,
    });
  };

  _onClickReactivate = () => {
    this.setState({
      showReactivateModal: true,
    });
  };

  _confirmReactivate = shouldResetPointBalance => {
    this.props.reactivateLoyalty({
      id: this.props.id,
      reset: shouldResetPointBalance,
    });
    this._closeReactivateModal('reactivate');
    clevertapCustomersLoyalty.reactivateLoyalty(this.props);
  };

  _closeReactivateModal = () => {
    this.setState({
      showReactivateModal: false,
    });
  };

  _changeLoyaltyStatus = () => {
    // switch the status
    const deactivateToggleFlag =
      !this.props.loyaltySubscription.subscriptionDetail['Loyalty Pro']
        .is_active && this.props.earning_rules[0].type === 'ITEM';
    if (!deactivateToggleFlag) {
      if (this.props.status === 'ACTIVE') {
        this._onClickDeactivate();
      } else {
        this._onClickReactivate();
      }
    }
  };
}

const selector = formValueSelector('existingForm');

const mapForm = {
  form: 'existingForm',
  touchOnBlur: false,
  touchOnChange: true,
};

function mapStateToProps(state) {
  return {
    summary: state.customers.list.summary,
    active: selector(state, 'active'),
  };
}

export default connect(mapStateToProps)(reduxForm(mapForm)(Existing));
